import type { State } from '~/store';

export function selectServiceRoutingCategoryNameInEditing(state: State) {
  return state.workflowEditor.ui?.components.services.serviceRoutingCategoryNameInEditing;
}

export function selectServiceActionOptionPublicIdInEditing(state: State) {
  return state.workflowEditor.ui?.components.services.serviceActionOptionPublicIdInEditing;
}
